<template>
  <div>
    <div v-if="item" v-disable-all="isReadonly">
      <div class="row my-3">
        <div class="col col-md-6">
          <div class="form-group required">
            <component-input
                label="Должность"
                v-model="item.position"
                placeholder="Введите должность"
                required/>
          </div>
        </div>
        <div class="col col-md-3">
          <div class="form-group required">
            <component-input
                label="Заработок от, руб"
                v-model="item.salaryFrom"
                placeholder="Введите нижнюю границу з/п"
                required/>
          </div>
        </div>
        <div class="col col-md-3">
          <div class="form-group required">
            <component-input
                label="Заработок до, руб"
                v-model="item.salaryTo"
                placeholder="Введите верхнюю границу з/п"
                required/>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="form-group col col-md-4">
          <label class="control-label">График работы</label>
          <div>
            <Select2 v-model="item.scheduleTypeId" :options="scheduleTypes" :settings="select2Settings"/>
          </div>
        </div>
        <div class="form-group col col-md-4">
          <label class="control-label">Доп. требования</label>
          <div>
            <Select2 v-model="item.scheduleTypeExtraIds" :options="scheduleTypeExtras"
                     :settings="{language:'ru',multiple:true}"/>
          </div>
        </div>
        <div class="form-group col col-md-4">
          <label class="control-label">Тип занятости</label>
          <div>
            <Select2 v-model="item.employmentTypeId" :options="employmentTypes" :settings="select2Settings"/>
          </div>
        </div>
      </div>
      <div class="row pt-2">
        <div class="form-group col col-md-8 required">
          <component-input
              label="Навыки и качества"
              v-model="item.skills"
              :required="true"
          />
        </div>
        <div class="form-group col col-md-4">
          <component-input
              label="Опыт работы, лет"
              v-model="item.workExperience"/>
        </div>
      </div>
      <div class="row pt-2">
        <div class="form-group col col-md-8">
          <label class="control-label">Профессиональная область</label>
          <div>
            <Select2
                :options="professionAreas"
                v-model="item.professionAreaId"
                :settings="select2Settings"
            />
          </div>
        </div>
        <div class="form-group col col-md-4 pt-4">
          <Checkbox v-model="item.isForPatient" id="isForPatient" text="Для ЛРАС" class="mt-2"/>
        </div>
      </div>
      <div class="row pt-2">
        <div class="form-group col col-md-12">
          <component-input
              label="Адрес рабочего места"
              v-model="item.workplaceAddress"
              placeholder="Введите адрес рабочего места"
          />
        </div>
      </div>
      <div class="row pt-2">
        <div class="form-group col col-md-12">
          <label class="control-label">Примечание</label>
          <textarea v-model="item.note" class="form-control" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="float-right d-flex align-items-center">
      <button-component class="btn btn-primary mx-2" v-if="!isReadonly" :disabled="isPost"
                        v-on:click="save">Сохранить
      </button-component>
      <button-component type="button" kind="secondary" class="btn btn-default" v-on:click="close">Закрыть
      </button-component>
    </div>
  </div>
</template>

<script>
import API from "../api/vacancyItem";
import Utils from "@/common/utils";
import Constants from '@/common/constants'
import {useVuelidate} from "@vuelidate/core";
import {required, minValue} from '@vuelidate/validators'
import ComponentInput from "../../../common/components/ComponentInput";
import ButtonComponent from "../../../common/ui/ButtonComponent";
import Checkbox from "../../../common/ui/checkbox";
import disableAll from "@/common/directives/disable-all";

export default {
  name: "VacancyItemCard",
  components: {Checkbox, ButtonComponent, ComponentInput},
  directives: {
    'disable-all': disableAll
  },
  props: {
    vacancyId: {
      type: Number,
      required: true
    },
    vacancyItemId: {
      type: Number,
      required: true
    },
    isReadonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      item: {},
      employmentTypes: [
        {id: null, text: Constants.emptySelectOptionText, selected: true},
      ],
      scheduleTypes: [
        {id: null, text: Constants.emptySelectOptionText, selected: true},
      ],
      scheduleTypeExtras: [],
      professionAreas: [],
      select2Settings: Constants.select2Settings,
      isPost: false
    }
  },
  created() {
    Utils.loadSelectOptions("professionArea", this.professionAreas);
    Utils.loadSelectOptions("employmentType", this.employmentTypes);
    Utils.loadSelectOptions("scheduleType", this.scheduleTypes);
    Utils.loadSelectOptions("scheduleTypeExtras", this.scheduleTypeExtras);
    this.loadCard();
  },
  methods: {
    loadCard() {
      if (this.vacancyItemId) {
        API.find(this.vacancyItemId)
            .then((response) => {
              this.item = response.data;
              if (Array.isArray(this.item.vacancyItemScheduleTypeExtra)) {
                this.item.scheduleTypeExtraIds = this.item.vacancyItemScheduleTypeExtra.map((x) => x.scheduleTypeExtraId);
              }
            });
      } else {
        this.item = {};
      }
    },
    save() {
      if (Array.isArray(this.item.scheduleTypeExtraIds)) {
        this.item.vacancyItemScheduleTypeExtra = this.item.scheduleTypeExtraIds.map((x) => ({scheduleTypeExtraId: x}));
      }
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей.', 'error');
        return;
      }
      this.isPost = true;
      if (!this.item.id) {
        this.item.vacancyId = this.vacancyId;
      }

      API.save(this.item)
          .then((response) => {
            Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
            if (response.data.success) {
              this.$emit('save', this.item);
            }
            this.isPost = false;
          })
          .catch(() => {
            this.isPost = false;
          });
    },
    close() {
      this.$emit('close');
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        position: {required},
        salaryFrom: {required, minValue: minValue(1)},
        salaryTo: {required, minValue: minValue(1)},
        skills: {required}
      }
    }
  }
}
</script>

<style scoped>

</style>